const API = 'http://pta.rslsolution.com/admin/';
// const API = 'https://ptacademy.online/admin/';
export default API